module.exports = __webpack_public_path__ + "static/media/0@3x.19e28ca9.png";